export default __webpack_public_path__ + "static/media/linkedin.e0b9d114.svg";